import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import * as SettingsModels from '../../models/settings/settings';
import { EnvironmentService } from '../environment.service';
import * as Models from "../../models/commonModels";

@Injectable({
  providedIn: 'root'
})
export class SettingsService {


  constructor(private httpClient: HttpClient,
    private environment: EnvironmentService) { }
 

  public get( ) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };
    // Search.RequestSignature = Math.random();

    return this.httpClient.post<Models.Response<SettingsModels.SettingsPreview>>(`${this.environment.getApiURL()}/settings/get`, null, options);
  } 
}
